var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"q-summit-guide-circle",class:{ 
        'q-summit-guide-circle--right': _vm.right,
        'q-summit-guide-circle--icon': _vm.$slots.default
    },style:({ background: _vm.$slots.default && _vm.computedColor, color: !_vm.$slots.default && _vm.computedColor })},[(!_vm.$slots.default)?_c('div',{staticClass:"q-summit-guide-circle__figure",style:({ 'border-color': _vm.color })}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }